import React from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from "reactstrap";
import {TagKeyValue} from "../../../stores/observables/tagKeyValue";
import Tag from "../tag/tag";
import Icon from "../common/icon/icon";
import {IconSource} from "../../../shared/enums/iconSource";
import "./tagOptionMenu.sass";
import classnames from "classnames";

interface ITagOptionMenuProps {
  /**
   * The list of values to display in the overflow menu
   */
  options: TagKeyValue[];
  /**
   * The placeholder to show in the overflow menu
   */
  placeHolder: TagKeyValue;
  /**
   * Callback for when an item is selected
   * @param option The selected item
   */
  onOptionSelected: (option: TagKeyValue) => void;
  /**
   * Soft disable for component, which does not apply any styling when preventing clicks
   */
  clickable?: boolean;
}

const TagOptionMenu: React.FC<ITagOptionMenuProps> = ({
  options,
  placeHolder: placeholder,
  onOptionSelected,
  clickable = true
}) => {
  return (
    <UncontrolledDropdown
      className="tag-option-menu"
      disabled={placeholder.tagType === "disabled" || !clickable}
    >
      <DropdownToggle
        data-testid={"tagOptionMenu"}
        className={classnames({clickable})}
      >
        <Tag type={placeholder.tagType}>
          {placeholder.label}
          <Icon source={IconSource.dropdown} />
        </Tag>
      </DropdownToggle>
      <DropdownMenu>
        {options.map((item) => (
          <DropdownItem
            tag={"div"}
            key={item.value}
            disabled={item.isDisabled}
            onClick={() => onOptionSelected(item)}
          >
            <Tag text={item.label} type={item.tagType} />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default TagOptionMenu;
